import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, LongTextInput, SelectArrayInput, TextInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CanViewExperimentId from '../../../../Common/Partials/Helpers/CanViewExperimentId';
import CanViewExperimentName from '../../../../Common/Partials/Helpers/CanViewExperimentName';
import CodeMirrorInput from '../../../../Common/Utils/CodeMirrorInput';
import CommonSettings from '../../../../Common/Partials/Settings';
import { domainsDropdown } from '../../StaticData/Domains';
import PaceInputs from '../../../../Common/Partials/PaceInputs';

const styles = createStyles({
  dropdown: {
    minWidth: 180
  },
  experimentName: {
    width: '90%'
  }
});

type Props = {
  classes: any,
  permissions: any,
  record: any,
  resource: string
};

const SettingsTab = (props: Props) => (
  <div style={{ paddingTop: 20, maxWidth: 1100 }}>
    <CommonSettings permissions={props.permissions} resource={props.resource} record={props.record} />

    <div style={{ display: 'flex', paddingTop: 20 }}>
      <div style={{ flex: 1, paddingRight: 15 }}>
        <Field name="domains" source="domains" component={SelectArrayInput} label="End Points" choices={domainsDropdown()} className={props.classes.dropdown} /><br />
      </div>
      <div style={{ flex: 1, paddingLeft: 15 }}>
        <PaceInputs />
      </div>
    </div><br />

    <div style={{ display: 'flex', border: '1px solid rgba(0, 0, 0, 0.1)', padding: 25 }}>
      <div style={{ flex: 1 }}>
        <Field name="experiments.experimental" source="experiments.experimental" component={BooleanInput} label="Experimental" style={{ width: '0' }} />
        <FormDataConsumer>
          {({ formData, ...rest }) => CanViewExperimentId(formData) &&
            <span>Experiment ID: {props.record.experiments && props.record.experiments.experiment_id}</span>
          }
        </FormDataConsumer>
      </div>
      <FormDataConsumer>
        {({ formData, ...rest }) => CanViewExperimentName(formData) &&
          <div style={{ flex: 1 }}>
            <Field name="experiments.experiment_name" source="experiments.experiment_name" component={TextInput} label="Experiment Name" className={props.classes.experimentName} /><br />
          </div>
        }
      </FormDataConsumer>
    </div>

    <Field name="targets" source="targets" component={LongTextInput} label="Key-Values" options={{ rowsMax: 10 }} /><br />
    <span style={{ color: 'rgba(0, 0, 0, 0.298039)' }}>
      Example key:value or key2:value2 (New Line Separator)
    </span><br /><br />

    <Field name="html_head" component={CodeMirrorInput} label="HTML <head>" mode="text/html" />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/SettingsTab.tsx